import LocationOnIcon from '@mui/icons-material/LocationOn'
import { ClickAwayListener, Fade, Popper } from '@mui/material'
import { ReactElement, useState } from 'react'
import { LatLngLiteral } from 'google-maps-react-markers'

type DragEventHandler = (event: MouseEvent, coordinates: { latLng: LatLngLiteral }) => void

type MarkerProps = {
    color?: string
    size?: 'small' | 'large'
    lat: number
    lng: number
    popup?: ReactElement
    onClick?: () => void
    onDragEnd?: DragEventHandler
    onDrag?: DragEventHandler
    draggable?: boolean
}

//lat and long needs to be passes as props to be displayed on the map but they are not used in the component
export const Marker = ({ color = 'marker.green', size = 'large', popup, onClick }: MarkerProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const [open, setOpen] = useState<boolean>(false)

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
        setOpen((previousOpen) => !previousOpen)
        onClick?.()
    }

    const handleClickAway = () => {
        setOpen(false)
    }

    return (
        <ClickAwayListener onClickAway={handleClickAway} mouseEvent="onMouseDown" touchEvent="onTouchStart">
            <div role="presentation">
                <div onClick={handleClick} role="icon">
                    <LocationOnIcon
                        fontSize={size === 'large' ? 'large' : 'medium'}
                        sx={{
                            color,
                            zIndex: 2,
                            transform: 'translateY(-33%)', // magic fix, please don't ask
                            '&:hover': {
                                cursor: 'pointer',
                                transform: 'translateY(-33%) scale(1.06)',
                            },
                        }}
                    />
                </div>
                {popup && (
                    <Popper
                        open={open}
                        anchorEl={anchorEl}
                        style={{ zIndex: 3 }}
                        transition
                        modifiers={[
                            {
                                name: 'flip',
                                enabled: false,
                            },
                            {
                                name: 'preventOverflow',
                                enabled: false,
                            },
                        ]}
                        placement="auto"
                    >
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={350}>
                                <div role="popup">{popup}</div>
                            </Fade>
                        )}
                    </Popper>
                )}
            </div>
        </ClickAwayListener>
    )
}

export default Marker
